.button-reset {
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
}

.button-gradient {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.button-content {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  position: relative;
  z-index: 1;
}
